import { GatewayAssujetti, GatewayConformite } from "@conformite/gateway";
import { axeToAvancementField } from "@src/assujettis/AssujettiConsts";

export type AssujettiInfoFormInput = {
  id?: string;
  name: string;
  surname: string;
  role: GatewayAssujetti.RoleAssujetti;
  email?: string;
  sirenCompany: string;
  optionalAxesDescription?: string;
  honorabilite?: boolean;
  formationContinueIas?: boolean;
  formationContinueIobsp?: boolean;
  capaciteProfessionnelleIas?: boolean;
  capaciteProfessionnelleIobsp?: boolean;
};

export const axeFormFieldEntries = Object.entries(axeToAvancementField) as [
  GatewayConformite.AxeConformiteAssujetti,
  keyof AssujettiInfoFormInput,
][];

export const axeFormFields = Object.values(axeToAvancementField);

export function getOptionalAxesFromValues(
  values: Partial<AssujettiInfoFormInput>
): GatewayConformite.AxeConformiteAssujetti[] {
  return axeFormFieldEntries
    .filter(([, field]) => values[field])
    .map(([axe]) => axe);
}

export function axesToDefaultValues(
  axes: GatewayConformite.AxeConformiteAssujetti[] | null | undefined
): Partial<AssujettiInfoFormInput> {
  return Object.fromEntries(
    axeFormFieldEntries.map(([axe, field]) => [field, !!axes?.includes(axe)])
  );
}
